import { useAuthStore } from '@/store/authStore'
import { hasPermission } from '@/lib/permissions'
import { ForbiddenPage } from '@/pages/ForbiddenPage'
import type { Permission } from '@/api/types'

interface PermissionRouteProps {
  permissions: Permission[]
  children: React.ReactNode
}

/** Visar barnen bara om användaren har alla angivna permissions, annars ett tydligt "saknar behörighet"-meddelande. */
export function PermissionRoute({ permissions, children }: PermissionRouteProps): React.ReactElement {
  const user = useAuthStore((state) => state.user)

  if (!hasPermission(user, ...permissions)) {
    return <ForbiddenPage />
  }

  return <>{children}</>
}
